import React from 'react'


const Index = () => {


  return (
   <div>
    <video></video>
    </div>
  )
}

export default Index
